import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/balance-sheet',
}).lazy(() => import('./balance-sheet.lazy').then((d) => d.Route))
